<template>
  <div class="foundPerson">
    <div class="foundPersonList">
        <div
          class="card"
          v-for="item in findPeopleList"
          :key="item.id"
          @click="gotoFoundDetail(item.id)"
        >
          <div class="iconAndTitle clearfix">
            <div class="iconFoundPerson" v-if="item.type == '0'">寻人</div>
            <div class="iconRecruit" v-else>招聘</div>
            <div class="title">{{ item.title }}</div>
          </div>
          <div class="word">{{ item.content }}</div>
          <div class="date">{{ item.publish_time }}</div>
        </div>
      <div class="issue" @click="gotoIssueFound">发布</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      findPeopleList: [],
    };
  },
  created() {
    this.getFoundPersonList();
  },
  methods: {
    async getFoundPersonList() {
      /* const result = await this.$http({
        url: "/findpeoplelist",
        method: "POST",
        headers: { "content-type": "application/x-www-form-urlencoded" },
        data: this.$qs.stringify({ page: this.page, pageSize: this.pageSize }),
      }); */
      const result = await this.$http.get("/peopleSearch/getPeopleSearch");
        this.findPeopleList=result.data;
    },

    gotoFoundDetail(id) {
      return this.$router.push({
        path: "/foundPersonDetail",
        query: { id: id },
      });
    },
    gotoIssueFound() {
      return this.$router.push("/issueFound");
    },
  },
};
</script>
<style lang="less" scoped>
.foundPerson {
  position: relative;
  .foundPersonList {
    position: relative;
    left: 5%;
    width: 90%;
    min-height: 100vh;
    .card {
      position: relative;
      margin-top: 15px;
      background: #ffffff;
      border: 1px solid #e1e1e1;
      border-radius: 15px;
      .iconAndTitle {
        margin: 5px 0 10px 5px;
        .iconFoundPerson {
          float: left;
          background: linear-gradient(270deg, #00706E, #00706E);
          font-weight: 400;
          color: #ffffff;
          border-radius: 15px;
          padding: 2px 8px;
        }
        .iconRecruit {
          float: left;
          background: linear-gradient(-90deg, #00706E, #00706E);
          font-weight: 400;
          color: #ffffff;
          border-radius: 15px;
          padding: 2px 8px;
        }
        .title {
          float: left;
          padding-top: 2px;
          margin-left: 8px;
          font-weight: bold;
          color: #333333;
        }
      }
      .word {
        position: relative;
        left: 2%;
        width: 96%;
        margin-bottom: 35px;
        text-indent: 2em;
        font-weight: 400;
        color: #666666;
        line-height: 1.5em;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
      }
      .date {
        position: absolute;
        right: 10px;
        bottom: 10px;
        font-weight: 400;
        color: #999999;
      }
    }
    .issue {
      position: fixed;
      right: 5%;
      top: 70%;
      height: 13.5vw;
      width: 14%;
      background-color: rgb(111, 167, 251);
      border-radius: 200px;
      text-align: center;
      line-height: 13.5vw;
      color: white;
    }
  }
}
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  *zoom: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/service/FoundPerson.vue